import type { FC } from 'react';
import type { ButtonProps as BaseButtonProps } from 'wix-style-react';
import { Button as BaseButton } from 'wix-style-react';
import styles from './Button.module.scss';
import c from 'clsx';

type TButtonProps = {
  height?: number;
} & BaseButtonProps;

export const Button: FC<TButtonProps> = (props) => {
  const { children, size, priority, className } = props;
  const classNames = c(
    styles.button,
    {
      [styles.primary]: priority === 'primary',
      [styles.secondary]: priority === 'secondary',
      [styles.medium]: size === 'medium',
      [styles.huge]: size === 'large',
    },
    className,
  );
  return (
    <BaseButton
      {...props}
      style={{ ...props.style, height: `${props.height}px` }}
      className={classNames}
    >
      {children}
    </BaseButton>
  );
};
